<script setup>
import { ref } from 'vue'
import countriesData from '@/assets/countries.json'

const props = defineProps(['modelValue', 'label', 'variant'])

const emit = defineEmits(['update:modelValue'])

// Mappa i dati dal JSON importato
const countries = ref(
  countriesData.map(country => ({
    code: country.isoAlpha2,
    name: country.name,
    flag: country.flag
  })).sort((a, b) => a.name.localeCompare(b.name))
)

const getFlagDataUrl = (flagBase64) => {
  return `data:image/png;base64,${flagBase64}`
}
</script>

<template>
  <v-autocomplete
    :model-value="modelValue"
    @update:model-value="$emit('update:modelValue', $event)"
    :items="countries"
    item-value="code"
    item-title="name"
    :label="label"
    :variant="variant"
    
  >
    <template v-slot:item="{ props, item }">
      <v-list-item v-bind="props">
        <template v-slot:prepend>
          <img 
            :src="getFlagDataUrl(item.raw.flag)" 
            :alt="item.raw.name"
            class="flag-icon mr-3"
          />
        </template>
      </v-list-item>
    </template>

    <template v-slot:selection="{ item }">
      <div class="d-flex align-center">
        <img 
          :src="getFlagDataUrl(item.raw.flag)" 
          :alt="item.raw.name"
          class="flag-icon mr-2"
        />
        <span>{{ item.raw.name }}</span>
      </div>
    </template>
  </v-autocomplete>
</template>

<style scoped>
.flag-icon {
  width: 32px;
  height: 24px;
  object-fit: cover;
  border-radius: 2px;
  border: 1px solid #ddd;
}
</style>
